import BottomDialog from '../../../../../../components/bottomDialog';

const LogBottomDialog = ({ dialogRef, closeBottomDialog, createLog }) => {
  return (
    <BottomDialog
      dialogRef={dialogRef}
      closeDialog={closeBottomDialog}
    >
      <div className='flex flex-col items-center gap-2'>
        <button
          className='border rounded-xl w-full py-2 bg-green-500 text-green-600 bg-opacity-20 border-green-500 border-opacity-60'
          onClick={createLog}
        >
          Complete
        </button>
        <button
          className='border rounded-xl w-full py-2 mt-4'
          onClick={closeBottomDialog}
        >
          Cancel
        </button>
      </div>
    </BottomDialog>
  );
};

export default LogBottomDialog;
